import React from 'react';
import { Redirect } from 'react-router-dom';
import DynamicImport from './DynamicImport';
import { getItemFromPersistentStore } from '../../utils/Persist';
import ROUTE_CONSTANTS from '../../constants/RouteConstants';
import getCookieValue from '../../utils/getCookieValue';
import NotFound from '../../containers/NotFound';
import Analytics from '../../../../common/utils/analyticsUtil';
import getQueryParamFromLink from '../../../../common/utils/getQueryParamFromLink';
import withRouterHOC from '../../../../common/components/WithRouteHOC';
import get from 'lodash/get';
import { setCountrySpecificPath, setCountryIsoCode } from './Constants';
import validateCountryIsoCode from '../../utils/validateCountryIsoCode';
import getRoutePath from '../../utils/getRoutePath';
// import OTPsignUp from '../../containers/OTPsignUp';

// const SignUp = props => (
//   <DynamicImport
//     /* eslint-disable max-len */
//     load={() =>
//       import('../../containers/signUp' /* webpackChunkName: 'SignUp' */)
//     }
//     componentProps={props}
//   />
// );
const OTPsignUp = props => (
  <DynamicImport
    /* eslint-disable max-len */
    load={() =>
      import(
        '../../containers/OTPsignUp' /* webpackChunkName: 'OTPsignUp' */
      )
    }
    componentProps={props}
  />
);

const SocialLogin = props => (
  <DynamicImport
    load={() =>
      /* eslint-disable max-len */
      import(
        '../../containers/signUp/socialLogin' /* webpackChunkName: 'SignUp' */
      )
    }
    componentProps={props}
  />
);

class PublicRoute extends React.Component {
  constructor(props) {
    super(props);
    this.logUTMParamsInGA(props);
  }

  logUTMParamsInGA = (props) => {
    const { history } = props;
    const queryParmSearchString = get(history, 'location.search', '');
    const externalParams = getQueryParamFromLink(queryParmSearchString);
    const isUTMSourcePresent = externalParams.hasOwnProperty('utm_source');
    const isUTMMediumPresent = externalParams.hasOwnProperty('utm_medium');
    const isUTMCampaignPresent = externalParams.hasOwnProperty('utm_campaign');
    if (isUTMSourcePresent) {
      Analytics.registerProperties({ utm_source: String(externalParams.utm_source) });
    }
    if (isUTMMediumPresent) {
      Analytics.registerProperties({ utm_medium: String(externalParams.utm_medium) });
    }
    if (isUTMCampaignPresent) {
      Analytics.registerProperties({ utm_campaign: String(externalParams.utm_campaign) });
    }
  }

  render() {
    const { isAuthorized, path, computedMatch, isCountrySpecificPath } = this.props;
    const isLoggedIn = getItemFromPersistentStore('isLoggedIn', false) || getCookieValue('isLoggedIn') === 'true';
    const isAutenticated = isLoggedIn === true;
    const countryIsoCode = get(computedMatch, 'params.country_iso_code', '');
    if (isAuthorized === false || (isCountrySpecificPath && !validateCountryIsoCode(countryIsoCode))) return <NotFound />;

    /*
     * Save values for country specific urls, which help in navigate country specific path only
     * Social Login path are redirect urls, not public urls, handling of country specific path in SocialLogin Component
    */
    if (path !== ROUTE_CONSTANTS.SOCIAL_LOGIN) {
      setCountrySpecificPath(isCountrySpecificPath);
      setCountryIsoCode(countryIsoCode);
    }

    if (
      isAutenticated &&
      (path === '/' || path === ROUTE_CONSTANTS.OTPSIGNUP_VIEW || path === ROUTE_CONSTANTS.OYO360_PROPERTY_ONBOARD || path === ROUTE_CONSTANTS.SOCIAL_LOGIN
        || path === ROUTE_CONSTANTS.OTPSIGNUP_VIEW_V2 || path === ROUTE_CONSTANTS.OYO360_PROPERTY_ONBOARD_V2)
    ) {
      return <Redirect to={{ pathname: getRoutePath({ path: ROUTE_CONSTANTS.PROPERTY_MIDDLEWARE_V2 }) }} />;
    }
    if (path === ROUTE_CONSTANTS.SOCIAL_LOGIN) {
      return <SocialLogin computedMatch={computedMatch} oauthState={getCookieValue('isLoggedIn')} />;
    }
    if (path === ROUTE_CONSTANTS.OTPSIGNUP_VIEW || path === ROUTE_CONSTANTS.OYO360_PROPERTY_ONBOARD ||
      path === ROUTE_CONSTANTS.OTPSIGNUP_VIEW_V2 || path === ROUTE_CONSTANTS.OYO360_PROPERTY_ONBOARD_V2) {
      return <OTPsignUp />;
    }
    return <OTPsignUp />
  }
}

export default withRouterHOC(PublicRoute);
